













import Vue from 'vue';

export default Vue.extend({
    name: 'SearchSelectFilter',
    props: {
        /** код для опознания значения в общем массиве фильтров */
        code: {
            type: String,
            required: true,
        },
        /** подпись */
        label: {
            type: String,
            required: false,
            default: 'Фильтр:',
        },
        /** набор значений */
        dataSet: {
            type: Array,
            required: true,
            default() {
                return [];
            }
        },
        /** поле-техт для отображения */
        textField: {
            type: String,
            required: true,
        },
        /** поле-значение */
        valueField: {
            type: String,
            required: true,
        },
        /** опция по умолчанию (не выбрано) */
        defaultOption: {
            type: Object,
            required: false,
            default() {
                return {
                    text: '',
                    value: null,
                };
            }
        },
        /** значение опредкляющее набор данных для фильтра */
        masterValue: {
            type: [String, Number],
            required: true,
        }
    },
    computed: {
        /** Составление из входного набора данных набора данных для компонента select */
        options(): Array<any> {
            const defaultOptions = [this.defaultOption];
            const inputOptions = (this.dataSet as Array<any>).map(item => {
                if (this.valueField === 'ALL_OBJECT') {
                    return {
                        text: item[this.textField],
                        value: item,
                    };
                } else {
                    return {
                        text: item[this.textField],
                        value: item[this.valueField],
                    };
                }
            });
            return defaultOptions.concat(inputOptions);
        }
    },
    methods: {
        inputHandler() {
            const resultObject = { code: this.code, value: this.selected };
            this.$emit('input', resultObject);
        },
    },
    watch: {
        masterValue: function(newVal, oldVal /** */): void {
            if (newVal !== oldVal) {
                this.selected = this.defaultOption.value;
                this.inputHandler();
            }
        },
    },
    data() {
        return {
            selected: null as any,
        };
    }
});
